import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../../constants/size'
import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../constants/validation'
import { FormModal } from '../../../Form'
import { performMockViewingReschedule } from '../../../RentalPortalViewing'

import {
  QA_NAME_VIEWING_RESCHEDULE_MODAL,
  QA_NAME_VIEWING_RESCHEDULE_SUBMIT,
  VIEWING_RESCHEDULE_FIELD_NAME,
} from './ViewingRescheduleModal.constants'
import {
  getViewingRescheduleInitialValues,
  getViewingReschedulePayload,
  getViewingRescheduleValidationSchema,
} from './ViewingRescheduleModal.utils'
import { ViewingRescheduleModalFields } from './ViewingRescheduleModalFields'

function ViewingRescheduleModal({ viewingData, onClose, onRescheduled }) {
  const { t } = useTranslation()

  async function handleSubmit({ setErrors, setSubmitting, values }) {
    return performMockViewingReschedule(
      getViewingReschedulePayload({ values, viewingData })
    )
      .then(response => {
        onRescheduled(response.data.viewing_id)
        onClose()
      })
      .catch(error => {
        setSubmitting(false)

        if (error?.isOverlap) {
          setErrors({
            [VIEWING_RESCHEDULE_FIELD_NAME.start]: t(
              'RentalPortal.ViewingFormOverlapKey'
            ),
          })
        } else {
          setErrors({
            [SERVER_NON_FIELD_ERROR_KEY]: t(
              'RentalPortal.ViewingFormSaveErrorKey'
            ),
          })
        }
      })
  }

  return (
    <FormModal
      Fields={ViewingRescheduleModalFields}
      containerProps={{
        boxSize: SIZE.LARGE,
        qaName: QA_NAME_VIEWING_RESCHEDULE_MODAL,
      }}
      formBodyProps={{
        submitButtonText: 'RentalPortal.ViewingRescheduleActionKey',
        submitQaName: QA_NAME_VIEWING_RESCHEDULE_SUBMIT,
        withNotifications: true,
      }}
      formTitle='RentalPortal.ViewingRescheduleActionKey'
      initialValues={getViewingRescheduleInitialValues({ t, viewingData })}
      validationSchema={getViewingRescheduleValidationSchema({
        t,
        viewingData,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ViewingRescheduleModal
